export const paymentRemarks = [
  { remark: "Advance" },
  { remark: "COD - cash" },
  { remark: "COD - cheque" },
  { remark: "Credit" }
];
